import React, { useEffect, useState } from "react";
import "./addGroup.css";
import { Camera, ChevronLeft, PlusIcon } from "lucide-react";
import Picture from "../../../assets/download.png";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import apiServiceHandler from "../../../service/apiService";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Spinner from "../../Spinner/Spinner";

const EditGroup = () => {
  const navigate = useNavigate();
  const [banner, setBanner] = useState(null);
  const [loading, setLoading] = useState(false);
  const [previewBanner, setPreviewBanner] = useState(Picture);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [groupInfo, setGroupInfo] = useState(null);

  const { pathname } = useLocation();
  const pathArr = pathname.split("/");
  const id = pathArr[pathArr.length - 1];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const getGroupInfo = async () => {
    try {
      const response = await apiServiceHandler("GET", `api/groups/${id}`, {});
      const groupData = response?.data[0];
      console.log(groupData)
      setGroupInfo(groupData);
      setFormData({
        name: groupData?.name ?? "",
        description: groupData?.description ?? "",
      });
      setBanner(groupData?.banner_image || Picture);
      setPreviewBanner(groupData?.banner_image || Picture)
    } catch (error) {
      console.error("Error getting group info:", error);
    }
  };

  useEffect(() => {
    getGroupInfo();
  }, []);

  const handleBannerChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBanner(file);
      setPreviewBanner(URL.createObjectURL(file));
    }
  };

  const handleSaveGroup = async () => {
    setLoading(true);
    const data = new FormData();
    if (banner) data.append("file", banner);
    data.append("id", groupInfo?._id)
    data.append("name", formData.name);
    data.append("description", formData.description);
    groupInfo?.members?.forEach((member) => {
        data.append("members[]", member);
    });

    try {
      const response = await apiServiceHandler("POST", "api/groups/update", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status) {
        toastr.success("Group updated successfully!");
        setTimeout(() => {
          setLoading(false);
          navigate("/groups");
        }, 1500);
      } else {
        toastr.error("Something went wrong! Please try again later.");
      }
    } catch (error) {
      console.error("Error updating group:", error);
      setLoading(false);
    }
  };

  return (
    <div className="">
      <div className="page-content">
        <div className="page-back">
          <button className="back-button" onClick={() => navigate(-1)}>
            <span className="icon">
              <ChevronLeft size={32} />
            </span>
            <span className="button-label">Back</span>
          </button>
        </div>
        <div className="add-group-page-header">
          {/* <div className="page-header-label">Groups</div> */}
          <div className="page-header-top">
            <div className="page-header-content">
              <div className="add-group-page-heading">Update Group</div>
            </div>
          </div>
        </div>
        <div className="add-group-page-section">
          <div className="add-group-page-section-header">
            <div className="add-group-header"></div>
            <div className="card-container">
              <div className="add-group-avatar">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleBannerChange}
                  id="banner-upload"
                  style={{ display: "none" }}
                />
                <button
                  className="add-group-avatar-button"
                  onClick={() => document.getElementById("banner-upload").click()}
                >
                  <span className="add-group-avatar-icon">
                    <Camera />
                  </span>
                  <span className="add-banner-btn-label">Edit Banner</span>
                </button>
                <img className="image" alt="Group Banner" src={previewBanner} />
              </div>
            </div>
            <div className="group-info">
              <div className="group-name">
                <label>Group Name</label>
                <div className="group-name-input">
                  <div className="group-name-input-wrapper">
                  <input
                    type="text"
                    className="group-name-input-text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                  </div>
                </div>
              </div>
              <div className="group-description">
                <label>Group Description</label>
                <div className="group-description-input">
                  <div className="group-description-input-wrapper">
                  <input
                    type="text"
                    name="description"
                    className="group-description-input-text"
                    value={formData.description}
                    onChange={handleChange}
                  />
                  </div>
                </div>
              </div>
              <div className="new-group-add">
                <button
                  className="new-group-add-btn"
                  onClick={handleSaveGroup}
                  disabled={loading}
                  style={loading ? { backgroundColor: "#268bd9", border: "none" } : {}}
                >
                  {loading ? <Spinner /> : <PlusIcon />}
                  <span className="new-group-add-label">
                    {loading ? "Updating" : "Update"}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditGroup;
